import { MOBILE_REGEX } from "../../Auth/Register/Components/regex";
export const isValidMobile = val => MOBILE_REGEX.test(val.trim());
export const mobileInputValidation = (value) => {
    let val = value.replace(/\D/g, "").slice(0, 10);
    return val;
}
export const validateMobile = (value) => {
    if (!value) {
        return { message: "Mobile number is required", valid: false };
    } 
    // Check for exactly 10 digits starting with 6-9
    else if (!isValidMobile(value)) {
        return { message: "Invalid mobile number", valid: false };
    } 
    // Check for repeated digits (e.g., 1111111111, 2222222222, etc.)
    else if (/^(\d)\1{9}$/.test(value)) {
        return { message: "Mobile number cannot be all repeated digits", valid: false };
    } else {
        return { message: "", valid: true };
    }
}